<template>
    <section>
        <shared-content :draft="isDraft" :story="blok.content" ></shared-content>
    </section>
</template>
<script>
import SharedContent from "./SharedContent.vue";
export default {
    name: 'library-content',
    props: ['blok'],
    components: {
        SharedContent
    },
    computed: {
        isDraft: function() {
            return this.$route.query.draft ? true : (this.$route.query._storyblok != '' ? true : false);
        }
    }
}
</script>
